import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M5.156 34.993v7.85h7.85l23.155-23.152-7.85-7.851L5.155 34.993Zm37.076-21.375a2.084 2.084 0 0 0 0-2.95l-4.899-4.9a2.087 2.087 0 0 0-2.951 0L30.55 9.599l7.851 7.85 3.831-3.83Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  l
];
function r(d, s) {
  return e(), o("svg", n, c);
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=edit.svg.mjs.map
